import React, { useContext } from "react"
import SP from "./Category/SP"
import PC from "./Category/PC"
import { PCViewContext } from "../../Common/PCViewContext"

import "./Styles/modal_transition.scss"
import "../../../styles/layouts"

const Category = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <React.Fragment>
      {isPC && <PC {...props} />}
      {!isPC && <SP {...props} />}
    </React.Fragment>
  )
}

export default Category
